/**
 * The status of a policy in the consumer's plan as a badge. The wording never suggests coverage is in
 * force: a selected policy is a choice and a sent application is not an issued policy.
 */
import { Badge } from '@design-system';
import type { ConsumerPolicyStatus } from '@shared/consumerPlan';
import { CONSUMER_POLICY_STATUS_LABEL } from '../lib/copy';

const VARIANT: Record<ConsumerPolicyStatus, 'default' | 'secondary' | 'outline'> = {
  'existing-policy': 'secondary',
  'added-quote': 'outline',
  'added-quote-not-applied': 'outline',
  'application-submitted': 'default',
};

export function PolicyStatusBadge({ status }: { status: ConsumerPolicyStatus }) {
  return (
    <Badge
      variant={VARIANT[status]}
      data-testid="policy-status-badge"
    >
      {CONSUMER_POLICY_STATUS_LABEL[status]}
    </Badge>
  );
}
